import { Button, Stack } from "@mui/material";
import { FC, useState } from "react";
import Popup from "@components/Popup";
import { SMALL_POPUP_WIDTH, XS_POPUP_HEIGHT } from "@/theme/primary";
import IntegerInput from "@components/IntegerInput";
import MessageService from "@/services/api/MessageService";

interface SkipPointPopupProps {
  user: UserWithColor;
  open: boolean;
  onClose: () => void;
}

const SkipPointPopup: FC<SkipPointPopupProps> = ({ user, open, onClose }) => {
  const [amountToSkip, setAmountToSkip] = useState(1);

  const handleClose = () => {
    setAmountToSkip(1);
    onClose();
  };

  const skipPointsAndClose = () => {
    MessageService.skipPoints(user.id, amountToSkip);
    handleClose();
  };

  return (
    <Popup
      title="Passer des points"
      open={open}
      onClose={() => handleClose()}
      modalSize={{ width: SMALL_POPUP_WIDTH, height: XS_POPUP_HEIGHT }}>
      <Stack justifyContent="space-around" spacing={9}>
        <IntegerInput
          label="Nombre de points à passer"
          value={`${amountToSkip}`}
          handleChange={(value) => setAmountToSkip(Number(value ?? "0"))}
          variant="outlined"
        />
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={5}>
          <Button variant="contained" onClick={() => skipPointsAndClose()} fullWidth>
            Passer {amountToSkip} point{amountToSkip > 1 ? "s" : ""}
          </Button>
          <Button variant="contained" onClick={() => handleClose()} fullWidth>
            Annuler
          </Button>
        </Stack>
      </Stack>
    </Popup>
  );
};

export default SkipPointPopup;
